"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormSwitchInput = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const core_1 = require("@bluebase/core");
const formik_1 = require("formik");
const react_1 = tslib_1.__importDefault(require("react"));
const BaseFormField = core_1.getComponent('BaseFormField');
const FormSwitchInput = (_a) => {
    var { type } = _a, props = tslib_1.__rest(_a, ["type"]);
    const BB = core_1.useBlueBase();
    const [field, , helpers] = formik_1.useField(props);
    const { setValue } = helpers;
    const value = field.value;
    const inputProps = Object.assign(Object.assign({ labelPlacement: 'start' }, props), { checked: Boolean(value), onValueChange: (_value, checked) => setValue(checked) });
    // Dirty Hack: We have to reduce vertical padding because
    // MUI checkboxes have their own padding
    const styles = {};
    const source = BB.Components.getMeta('Switch', 'source', {});
    if (source.type === 'plugin' && source.key === 'material-ui') {
        styles.root = {
            paddingVertical: 4,
        };
    }
    // End of Dirty Hack
    return react_1.default.createElement(BaseFormField, Object.assign({ MainComponent: components_1.Switch, styles: styles }, inputProps));
};
exports.FormSwitchInput = FormSwitchInput;
exports.FormSwitchInput.defaultProps = {};
